import { SHARED_ERROR_AND_WARNING_VALUE } from './shared';

export const STAGES_VALUE_FIELDS = {
  ERROR: 'error',
  LOADING: 'loading',
};

export const STAGES_LOADING_VALUES = {
  LOADING: 'loading',
  LOADED: 'loaded',
};

export const DEFAULT_STAGES_VALUE = {
  [STAGES_VALUE_FIELDS.ERROR]: { ...SHARED_ERROR_AND_WARNING_VALUE },
  [STAGES_VALUE_FIELDS.LOADING]: undefined,
};

export const STAGES_FIELDS = {
  CREATE_NEW_INSURANCE: 'create-new-insurance',
  GET_APPLICATION: 'get-application',
  GET_CAR_INSTANCE: 'get-car-instance',
  GET_CUSTOMERS: 'get-customers',
  GET_DRIVER_CUSTOMERS: 'get-driver-customers',
  GET_INSURANCE_ORDER: 'get-insurance-order',
  GET_INSURER_CUSTOMER: 'get-insurer-customer',
  GET_OWNER_CUSTOMER: 'get-owner-customer',
  GET_WORKSHEET: 'get-worksheet',
  MOVE_TO_INSURANCE_PRODUCTS_WITH_PARAMS: 'move-to-insurance-products-with-params',
  MOVE_TO_INSURER_INFO_STATE: 'move-to-insurer-info-state',
  SELECT_BRAND: 'select-brand',
  SELECT_MODEL: 'select-model',
  SELECT_VERSION: 'select-version',
  UPDATE_CAR_INSTANCE: 'update-car-instance',
  UPDATE_DRIVER_CUSTOMERS: 'update-driver-customers',
  UPDATE_INSURER_CUSTOMER: 'update-insurer-customer',
  UPDATE_OWNER_CUSTOMER: 'update-owner-customer',
  VIN_RECOGNITION: 'vin-recognition',
};
